import React, { useState } from "react";
import { useTenants } from "../hooks/useDevices";
import { api } from "../services/api";

interface DashboardHeaderProps {
  selectedTenantId?: string;
  onSelectTenant?: (tenantId: string) => void;
  onRefresh?: () => void;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  selectedTenantId,
  onSelectTenant,
  onRefresh,
}) => {
  const { data: tenants } = useTenants();
  const safeTenants = tenants || [];
  const [showSettings, setShowSettings] = useState(false);
  const [apiKeyInput, setApiKeyInput] = useState(api.getApiKey());

  const handleSaveApiKey = (e: React.FormEvent) => {
    e.preventDefault();
    api.setApiKey(apiKeyInput.trim());
    setShowSettings(false);
    if (onRefresh) onRefresh();
  };

  return (
    <header className="dashboard-header card margin-bottom">
      <div className="header-content">
        <div className="header-brand">
          <div className="logo-icon">🌐</div>
          <div>
            <h1>MeshRouter SaaS Control Plane</h1>
            <p>MikroTik Secure Mesh VPN Fleet Manager</p>
          </div>
        </div>

        <div className="header-controls">
          {safeTenants.length > 0 && (
            <div className="tenant-selector">
              <label htmlFor="tenant-select">Tenant:</label>
              <select
                id="tenant-select"
                value={selectedTenantId || ""}
                onChange={(e) => onSelectTenant && onSelectTenant(e.target.value)}
              >
                <option value="">All Tenants</option>
                {safeTenants.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.name} ({t.slug || t.id})
                  </option>
                ))}
              </select>
            </div>
          )}

          <button
            className="btn btn-secondary btn-sm"
            onClick={onRefresh}
            title="Refresh fleet telemetry"
          >
            🔄 Sync Data
          </button>

          <button
            className="btn btn-outline btn-sm"
            onClick={() => setShowSettings(!showSettings)}
          >
            ⚙️ Settings
          </button>
        </div>
      </div>

      {showSettings && (
        <form onSubmit={handleSaveApiKey} className="settings-drawer margin-top">
          <div className="form-group inline-group">
            <label htmlFor="api-key-input">Control Plane X-API-Key:</label>
            <input
              id="api-key-input"
              type="password"
              value={apiKeyInput}
              onChange={(e) => setApiKeyInput(e.target.value)}
              placeholder="Enter X-API-Key..."
              required
            />
            <button type="submit" className="btn btn-primary btn-sm">
              Save Key
            </button>
          </div>
        </form>
      )}
    </header>
  );
};